import { render, staticRenderFns } from "./MultimediaModal.vue?vue&type=template&id=64024fb8&scoped=true"
import script from "./MultimediaModal.vue?vue&type=script&lang=js"
export * from "./MultimediaModal.vue?vue&type=script&lang=js"
import style0 from "./MultimediaModal.vue?vue&type=style&index=0&id=64024fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64024fb8",
  null
  
)

export default component.exports